import React, { PureComponent } from 'react';
import { Slider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import './slider.scss';

const SenseLoafSlider = withStyles({
  valueLabel: {
    left: 'calc(-50% + -4px)',
    top: -22,
    fontSize: '14px',
    '& *': {
      background: 'transparent',
      color: '#000',
    },
  },
})(Slider);

class CommonSlider extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sliderValue: props.value || 0,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({
        sliderValue: this.props.value,
      });
    }
  }

  onChange = (e, sliderValue) => {
    this.setState({
      sliderValue,
    });
  };

  render() {
    const { max, onChange, valueLabelFormat } = this.props;
    const { sliderValue } = this.state;
    const valueLabel = valueLabelFormat ? valueLabelFormat : (v) => v;
    return (
      <SenseLoafSlider
        max={max}
        value={sliderValue}
        onChangeCommitted={onChange}
        onChange={this.onChange}
        valueLabelDisplay="on"
        valueLabelFormat={valueLabel}
      />
    );
  }
}

export default CommonSlider;
